import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var yogoIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm4.69 19.733a3.953 3.953 0 0 1-3.947-3.96 6.2 6.2 0 0 1 .55-2.183c.19-.511.378-1.019.567-1.523.476-1.194.83-2.433 1.06-3.697.157-1 .14-2.227-.623-3-.584-.587-1.487-.703-2.297-.723s-1.713.136-2.297.726c-.763.77-.78 2-.623 3 .23 1.264.585 2.5 1.06 3.694.187.506.376 1.014.567 1.523a6.2 6.2 0 0 1 .55 2.183 3.943 3.943 0 0 1-7.61 1.474 2.573 2.573 0 0 0 3.77-.31c.532-.72.693-1.65.433-2.507-.257-.93-.82-1.667-1.27-2.547-1.463-2.5-1.403-4.37-1.403-4.37 0-3.73 3.56-4.363 6.823-4.363 3.263 0 6.823.633 6.823 4.363 0 0 .06 1.87-1.403 4.37-.45.864-1 1.617-1.27 2.547-.26.857-.1 1.787.433 2.507a2.573 2.573 0 0 0 3.77.31 3.947 3.947 0 0 1-3.663 2.486z",
  fill: "currentColor"
}));

export { yogoIcon as default };
//# sourceMappingURL=yogoIcon.js.map
